import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

/* tour-data-store state */
import { TourDataStoreModule } from './tour-data-store/tour-data-store.module';
/* rooming-per-day-data-store state */
import { RoomingPerDayDataStoreModule } from './rooming-per-day-data-store/rooming-per-day-data-store.module';
/* settings-data-store state */
import { SettingsDataStoreModule } from './settings-data-store/settings-data-store.module';
/* router-data-store state */
import { RouterDataStoreModule } from './router-data-store/router-data-store.module';
/* transportation-data-store state */
import { TransportationDataStoreModule } from './transportation-data-store/transportation-data-store.module';
/* daily-program-item-data-store state */
import { DailyProgramItemDataStoreModule } from './daily-program-item-data-store/daily-program-item-data-store.module';
/* client-data-store state */
import { ClientDataStoreModule } from './client-data-store/client-data-store.module';
/* rooming-data-store state */
import { RoomingDataStoreModule } from './rooming-data-store/rooming-data-store.module';
/* auth-data-store state */
import { AuthDataStoreModule } from './auth-data-store/auth-data-store.module';
/* app-data-store state */
import { AppDataStoreModule } from './app-data-store/app-data-store.module';
/* accommodation-data-store state */
import { AccommodationDataStoreModule } from './accommodation-data-store/accommodation-data-store.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* AppDataStore state */
    AppDataStoreModule,
    /* TourDataStore state */
    TourDataStoreModule,
    /* RoomingPerDayDataStore state */
    RoomingPerDayDataStoreModule,
    /* SettingsDataStore state */
    SettingsDataStoreModule,
    /* RouterDataStore state */
    RouterDataStoreModule,
    /* TransportationDataStore state */
    TransportationDataStoreModule,
    /* DailyProgramItemDataStore state */
    DailyProgramItemDataStoreModule,
    /* ClientDataStore state */
    ClientDataStoreModule,
    /* RoomingDataStore state */
    RoomingDataStoreModule,
    /* AuthDataStore state */
    AuthDataStoreModule,
    /* AccommodationDataStore state */
    AccommodationDataStoreModule,
  ],
  exports: [StoreModule, EffectsModule],
})
export class DataStoresModule {}
